export default __webpack_public_path__ + "static/media/p6.f2e155c6.png";